import {
  formatPercentageValue,
  createKpiTileItem,
  formatNormalNumber,
} from '../../../../utils/helper';

export default {
  type: 'KpiTile',
  handler: (data, title = 'Unique Users') => {
    const { uniqueSessions, uniqueSessionsDelta } =
      data.getUserAdoptionScorecard;

    return createKpiTileItem(
      title,
      formatNormalNumber(uniqueSessions),
      uniqueSessionsDelta
        ? {
            isPositiveValue: uniqueSessionsDelta >= 0,
            text: formatPercentageValue(Math.abs(uniqueSessionsDelta)),
            sideLabel: '',
            showArrow: Number(uniqueSessionsDelta) !== 0,
          }
        : null
    );
  },
};
